import type { Components, Theme } from "@mui/material/styles";

import { INPUT_PADDING_SPACING } from "./input-base";

export const MuiFormHelperText: Components<Theme>["MuiFormHelperText"] = {
  styleOverrides: {
    // Line the text up with the input's horizontal padding
    root: ({ theme }) => ({
      marginTop: theme.spacing(0.5),
      marginLeft: theme.spacing(INPUT_PADDING_SPACING),
      marginRight: theme.spacing(INPUT_PADDING_SPACING),
    }),
  },
};
